import * as React from 'react';
import { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import { Container } from 'react-bootstrap';
import { ApiDelete, ApiGet } from '../../helper/API/ApiData';
import { useNavigate } from 'react-router-dom';
import { cleanData, getHeading } from '../../utils/helper';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { ToggleButton } from 'primereact/togglebutton';
import MobilizationDashboard from '../Dashboard/MobilizationDashboard';
const MAX_STRING_LENGTH = 15
export interface IListMemberProps {

}

export const ListMember = (props: IListMemberProps) => {

  const navigate = useNavigate()

  const dt = React.useRef<DataTable<any>>(null)

  const [members, setMembers] = useState([])
  const [deletedMembers, setDeletedMembers] = useState(false)
  const [filters, setFilters] = useState<any>(null);
  const [showSelectedMembers, setShowSelectedMembers] = useState<boolean>(false);
  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const initialVisibleColumns = [
    // {field: 'name', header: 'project_name'},
    // {field: 'project_partner', header: 'project_partner'},
    // {field: 'registration_number', header: 'registration_number'},
    // {field: 'groupMemberDetails.length', header: 'number_of_members'},
    // {field: 'name', header: 'project_name'},
    'name',
    'location',
    'partner_name',
    'shg_name',
    'total_money_saved',
    'training_status',
    'enterprise_status'
  ]
  const [visibleColumns, setVisibleColumns] = useState(initialVisibleColumns)
  const [allColumns, setAllColumns] = useState<string[]>([])
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    ApiGet('member')
      .then((res: any) => {
        if (res && res.status === 200) {
          if (res && res.data) {
            setMembers(res.data)
            // setAllColumns(Object.keys(res.data[0]))
            setAllColumns([
              ...initialVisibleColumns,
              ...Object.keys(res.data[0]),
            ])
            // setAllColumns(Object.keys(res.data[0]).filter(val => !initialVisibleColumns.includes(val)))
          }
        }
      })

    initFilters();
  }, [deletedMembers])


  useEffect(() => {
    if (checked) {
      setVisibleColumns(allColumns)
    }
    else {
      setVisibleColumns(initialVisibleColumns)
    }
  }, [checked])

  const handleUpdate = (memberId: string): void => {
    navigate(`add/?id=${memberId}`)
  }

  const handleDelete = (memberId: string): void => {
    swal({
      title: "Are you sure?",
      text: "you want to delete member?",
      icon: "error",
      buttons: ["cancel", "ok"],
      dangerMode: true,
    }).then((result) => {
      if (result) {
        ApiDelete(`member/${memberId}`, {})
          .then((res: any) => {
            if (res.status === 200) {
              toast.success("Successfully deleted the member")
              // Refetch the members list
              setDeletedMembers(!deletedMembers)
            }
          })
          .catch((error) => {
            if (typeof error === 'string') {
              toast.error(error)
            }
            return error
          })
      }
    })
  }


  const renderHeader = () => {
    return (
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <div className='d-flex align-items-center justify-content-center'>
          <span className="text-xxl text-900 font-bold">Member List</span>
          <Button icon="pi pi-plus" outlined style={{ borderRadius: "50%", marginLeft: 20 }} onClick={() => navigate('/shgadmin/member/add')} />
        </div>
        <div className="d-flex">
          <Button type="button" className={`btn ${showSelectedMembers ? 'btn-primary' : 'btn-outline-primary'} me-2`} label="Selected" onClick={toggleSelected} />
          <Button type="button" className="btn btn-outline-primary me-2" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} />
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
          </span>
        </div>
      </div>
    );
  };

  const toggleSelected = () => {
    let _filters: any = { ...filters };

    _filters['selected'].value = !showSelectedMembers;

    setFilters(_filters);
    setShowSelectedMembers(!showSelectedMembers);
  }

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters: any = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      selected: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    setGlobalFilterValue('');
  };


  const actionBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" size="small" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={() => handleUpdate(rowData.id)} />
        <Button icon="pi pi-trash" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="danger" onClick={() => handleDelete(rowData.id)} />
      </React.Fragment>
    );
  };


  const customBodyTemplate = (rowData: any, field: string) => {
    if (typeof rowData[field] === 'string') {
      return (
        <React.Fragment>
          <p title={rowData[field]} className="">{rowData[field].substring(0, MAX_STRING_LENGTH)}{rowData[field].length > MAX_STRING_LENGTH ? '...' : ''}</p>
        </React.Fragment>
      )
    }
    if (typeof rowData[field] === 'boolean') {
      return (
        <React.Fragment>
          <span className={rowData[field] ? "pi pi-check" : "pi pi-times"}></span>
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <p title={rowData[field]} className="">{rowData[field]}</p>
      </React.Fragment>
    )
  }


  const exportCSV = (selectionOnly: boolean) => {
    dt.current?.exportCSV({ selectionOnly });
  };

  return (
    <Container fluid>

      {<MobilizationDashboard showChart={false} />}

      <div className="card p-3 m-3">
        <DataTable
          size={'small'}
          ref={dt}
          value={members}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          header={renderHeader}
          globalFilterFields={['name', 'location', 'address', 'email_id', 'contact_number', 'partner_name']}
          filters={filters}
          footer={
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                  label="Export" onClick={() => exportCSV(false)} className="w-8rem" />
                <ToggleButton
                  onLabel="Hide Columns" offLabel="Show Columns" onIcon="pi pi-eye-slash" offIcon="pi pi-eye"
                  checked={checked} onChange={(e) => setChecked(e.value)} className="w-8rem" />
                {/* <ToggleButton type="button" icon="pi pi-eye" label="View all columns" onClick={clearFilter} /> */}
              </div>
            </>
          }
        >

          {visibleColumns.length > 0 && visibleColumns.map((memberField, index) => {
            if (memberField !== 'id' && memberField !== 'groupDetails') {
              return (
                <Column body={(rowData: any) => customBodyTemplate(rowData, memberField)} sortable={memberField === 'date_of_screening'} key={memberField} field={memberField} header={getHeading(memberField)}></Column>
              )
            }
          })}
          <Column body={actionBodyTemplate} style={{ minWidth: '12rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
        </DataTable>
      </div>
    </Container>
  );
}

